import {
  fetchDebtorBalanceStatement,
  fetchDebtorBalanceStatementExport,
  fetchDebtorBalanceSummary,
  fetchDebtorBalanceSummaryExport,
} from '@views/customersBalance/query-api'
import { normalizeDebtorLedgerEntry } from '@views/customersBalance/utils/normalizeDebtorBalanceStatement'
import { normalizeDebtorBalanceContact } from '@views/customersBalance/utils/normalizeDebtorBalanceSummary'

import { NotificationKeys } from '../../../enums/notificationKeys'
import { QueryKeys } from '../../../enums/queryKeys'
import { TableIds } from '../../../enums/tableIds'
import { reactRoute } from '../../../utils/routing/reactRoute'
import { BalanceFilterType } from '../enums/balanceFilterType'
import { BalanceSide } from '../enums/balanceSide'
import { BalanceSortProperty } from '../enums/balanceSortProperty'
import { LEDGER_ENTRY_SORT_BY } from '../enums/ledgerEntryColumn'
import type { BalanceSideConfig } from './balanceSideConfig'

export const customerBalanceConfig: BalanceSideConfig = {
  side: BalanceSide.Customer,
  i18nPrefix: 'customers_balance',
  trackingObject: 'Customer Balance',

  getMainRoute: () => reactRoute.organization.customersBalance.getMainRoute(),
  getDetailRoute: (id = ':id') => reactRoute.organization.customersBalance.getDetailRoute(id),
  filtersUrlQueryKey: 'customersBalanceFilters',
  tableId: TableIds.CustomersBalance,
  defaultPageSize: 100,

  filterTypeOrder: [BalanceFilterType.Account, BalanceFilterType.BalanceDirection],
  filterTypeMeta: {
    [BalanceFilterType.Account]: { labelKey: 'customers_balance.filters.account.label', icon: 'usersRound' },
    [BalanceFilterType.BalanceDirection]: {
      labelKey: 'customers_balance.filters.balance_direction.label',
      icon: 'arrowRightLeft',
    },
  },
  defaultSortBy: BalanceSortProperty.AccountNumber,
  ledgerSortByMap: LEDGER_ENTRY_SORT_BY,

  querySummaryKey: QueryKeys.DebtorBalanceSummary,
  queryStatementKey: QueryKeys.DebtorBalanceStatement,
  querySummaryAccountsKey: QueryKeys.DebtorBalanceSummaryAccounts,

  exportNotificationKey: NotificationKeys.CustomersBalanceExport,

  fetchSummary: fetchDebtorBalanceSummary,
  // There is no dedicated "accounts" endpoint — the accounts list is derived from the summary
  // response, mirroring `views/suppliersBalance/hooks/useFetchCreditorBalanceSummaryAccounts.ts`.
  fetchSummaryAccounts: fetchDebtorBalanceSummary,
  fetchStatement: fetchDebtorBalanceStatement,
  fetchSummaryExport: fetchDebtorBalanceSummaryExport,
  fetchStatementExport: fetchDebtorBalanceStatementExport,
  normalizeSummaryContact: normalizeDebtorBalanceContact,
  normalizeStatementEntry: normalizeDebtorLedgerEntry,
}
